import NavBar from "./Components/NavBar";
import ItemPanel from "./Components/ItemPanel";
import "./CSS/panel.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useState, useEffect, useRef } from "react";
import Prueba from "./Components/Prueba";
import { useParams, Link } from "react-router-dom";
import { getDoc, setDoc, doc } from "firebase/firestore";
import { collection, getDocs, query } from "firebase/firestore";
import { db } from "./FirebaseConfig/firebase";
import { toPng } from "html-to-image";
import EntradaParrilla from "./Components/EntradaParrilla";
import TicketSalon from "./Components/TicketSalon";
import TicketParrilla from "./Components/TicketParrilla";

const MySwal = withReactContent(Swal);

function RegistroExitosoParrilla() {
  const navigate = useNavigate();
  const { idReservaParrilla } = useParams();

  const [nombre, setNombre] = useState("");
  const [fecha, setFecha] = useState("");

  const [nombreParticipante, setNombreParticipante] = useState("");
  const [fechaReserva, setFechaReserva] = useState("");
  const [zona, setZona] = useState("");
  const [estadoPago, setEstadoPago] = useState("");
  const [categoriasEdad, setCategoriasEdad] = useState("");

  const [invitados, setInvitados] = useState([]);
  const [observaciones, setObservaciones] = useState([]);
  const [montoTotal, setMontoTotal] = useState(0);

  //PRUEBA

  const [imageUrl, setImageUrl] = useState(null);
  const containerRef = useRef(null);
  const containerRefSalonPC = useRef(null);

  const [esCelular, setEsCelular] = useState(true);
  const [datosCargados, setDatosCargados] = useState(true); // MOSTRAR BARRA DE CARGA
  const elementos = [
    {
      nombre: "ZONA 1",
      id: "zona1",
    },
    {
      nombre: "ZONA 2",
      id: "zona2",
    },
    {
      nombre: "ZONA 3",
      id: "zona3",
    },
    {
      nombre: "ZONA 4",
      id: "zona4",
    },
    {
      nombre: "ZONA 5",
      id: "zona5",
    },
    {
      nombre: "ZONA 6",
      id: "zona6",
    },
    {
      nombre: "CAJA CHINA 1",
      id: "caja1",
    },
    {
      nombre: "CAJA CHINA 2",
      id: "caja2",
    },
  ];
  const handleConvert = () => {
    //console.log("es celular ? " + esCelular);
    toPng(containerRefSalonPC.current)
      .then(function (dataUrl) {
        setImageUrl(dataUrl);
      })
      .catch(function (error) {
        //console.error("Oops, algo salió mal!", error);
      });
  };
  const estadoDePago = () => {
    let pagados = 0;
    let noPagados = 0;

    for (const objeto of invitados) {
      if (objeto.estado === "Pagado") {
        pagados++;
      } else if (objeto.estado === "No pagado") {
        noPagados++;
      }
    }
    const resultado = `Pagado(${pagados})  , No Pagado(${noPagados})`;
    setEstadoPago(resultado);
  };

  const categoriaEdad = () => {
    let adultos = 0;
    let niños = 0;

    for (const objeto of invitados) {
      if (objeto.categoriaEdad === "Adulto") {
        adultos++;
      } else if (objeto.categoriaEdad === "Niño") {
        niños++;
      }
    }
    let adultoString = adultos > 0 ? `${adultos} Adulto(s)` : "";
    let niñoString = niños > 0 ? `${niños} Niño(s)` : "";
    setMontoTotal(adultos * 5 + niños * 3);
    const resultado = adultoString + " " + niñoString;
    setCategoriasEdad(resultado);
  };

  const handleDownload = () => {
    handleConvert();
    new Promise((res) => setTimeout(res, 2000));

    const downloadLink = document.createElement("a");
    downloadLink.href = imageUrl;
    downloadLink.download = nombre + " " + nombreParticipante;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  useEffect(() => {
    handleConvert();
  }, [esCelular]);
  useEffect(() => {
    estadoDePago();
    categoriaEdad();
  }, [invitados]);
  //Funcion para mostrar detalles de la reserva
  const getEntradaById = async () => {
    const invitados = collection(
      db,
      `PARRILLAS/${idReservaParrilla}/INVITADOS`
    );

    const evento = await getDoc(doc(db, `PARRILLAS`, idReservaParrilla));
    if (evento) {
      setNombreParticipante(
        evento.data().nombre + " " + evento.data().apellidos
      );
      setFecha(evento.data().fecha);
      setZona(
        elementos.find((elemento) => elemento.id === evento.data().zona).nombre
      );
      setFechaReserva(evento.data().fechaReserva);
      setEstadoPago(evento.data().estado);
      setObservaciones(evento.data().observaciones);
      const q = query(invitados);
      const data = await getDocs(q);

      setInvitados(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    } else {
    }
    setDatosCargados(false);

    handleConvert();
  };

  //cerrar agregar evento
  const cerrar = () => {
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      navigate("../panelUser");
    } else {
      if (localStorage.getItem("nombreLocal") == "CIP") {
        navigate("../panelCDA");
      } else {
        if (localStorage.getItem("nivelUsuario") == "admin") {
          navigate("../panelAdmin");
        } else {
          navigate("../login");
        }
      }
    }
  };

  useEffect(() => {
    getEntradaById();
    const esCelular = /Mobi|Android/i.test(navigator.userAgent);
    setEsCelular(esCelular);
    setDatosCargados(true);
  }, []);

  return (
    <div className="panel">
      <NavBar
        titulo="Descarga Ticket"
        imagen="cerrar"
        logoTitulo="cupon"
        cerrar={cerrar}
      ></NavBar>
      <div className="congrats">
        <h1 className="tituloFeli">Detalles del ticket</h1>
        <div className="ticket-card">
          {datosCargados ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                margin: "0px auto",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ verticalAlign: "middle", display: "block" }}>
                <div>
                  <img
                    style={{ height: "300px" }}
                    src={require(`./img/docucargando.gif`)}
                    alt="esperando"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="ticket">
              <div ref={containerRefSalonPC}>
                {esCelular ? (
                  <div>
                    <EntradaParrilla
                      fecha={fecha}
                      nombreParticipante={nombreParticipante}
                      idReservaParrilla={idReservaParrilla}
                      fechaReserva={fechaReserva}
                      zona={zona}
                      numeroParticipantes={invitados.length}
                      estadoPago={estadoPago}
                      categoriasEdad={categoriasEdad}
                      observaciones={observaciones}
                      handleConvert={handleConvert}
					  montoTotal={montoTotal}
                    />
                  </div>
                ) : (
                  <div>
                    <TicketParrilla
                      fecha={fecha}
                      nombreParticipante={nombreParticipante}
                      idReservaParrilla={idReservaParrilla}
                      fechaReserva={fechaReserva}
                      zona={zona}
                      numeroParticipantes={invitados.length}
                      estadoPago={estadoPago}
                      categoriasEdad={categoriasEdad}
                      observaciones={observaciones}
                      handleConvert={handleConvert}
					  montoTotal={montoTotal}

                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div style={{ paddingBottom: "3em", textAlign: "center" }}>
          <div className="boton-contenedor">
            <button className="boton" onClick={handleDownload}>
              Descargar ticket
            </button>
          </div>
          <h1
            style={{ color: "red", fontWeight: "lighter", marginTop: "30px" }}
          >
            Descargue e imprima el ticket para presentarlo el día de reserva.
          </h1>
          <h1 style={{ color: "red", fontWeight: "bold" }}>
            Podrá completar su lista de 20 invitados el día del evento.
          </h1>
        </div>
      </div>
    </div>
  );
}

export default RegistroExitosoParrilla;
